import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_r8df7y7ey2: FaireCollectionEntity = {
  token: "pbc_r8df7y7ey2",
  type: "collection",
  name: "scripture prints",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7b7053c995a1cbc9ce4e1b451b97e6578a37dc8234f56ee4df57b44360953027.jpeg",
  itemCount: 40,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:24.258Z",
    importedBy: "entity-db-import-collections",
  },
};
